import { motion, AnimatePresence } from "framer-motion";

const fadeInUpVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.7, ease: "easeOut" } },
  exit: { opacity: 0, y: -30, transition: { duration: 0.4, ease: "easeIn" } },
};

const AboutPage = ({ goToPage, isActive }) => {
  return (
    <div className="page intro-page">
      <div className="grid-background"></div>
      <AnimatePresence>
        {isActive && (
          <motion.div
            className="intro-content"
            key="intro-content"
            variants={fadeInUpVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
          >
            <span className="section-eyebrow">ABOUT</span>
            <h2>HELLO.</h2>
            <p>
              Nice to meet you! I'm Mohit, a full-stack software engineer based
              in Bengaluru, India. I love to solve problems and create
              innovative solutions that make a difference.
            </p>
            <p>
              I enjoy running on a good day and listening to hip-hop while
              building cool new projects.
            </p>
            <button
              className="cta-button"
              type="button"
              onClick={() => goToPage(2)}
            >
              View my professional journey
            </button>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default AboutPage;
